// Empty optional comments used to be converted to this placeholder before
// case creation. Treat it as absent both while building new payloads and when
// rendering cases that were already created with the legacy value.
export const normalizeAdditionalInfo = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;

  const normalized = value.trim();
  if (!normalized || normalized.toLowerCase() === 'n/a') return undefined;

  return normalized;
};
